export const tokens = {
  backgroundColorDefault: "var(--goto-background-color-default)",
  backgroundColorSecondary: "var(--goto-background-color-secondary)",
  surfaceColorDefault: "var(--goto-surface-color-default)",
  surfaceColorDefaultSemitransparent: "var(--goto-surface-color-default-semitransparent)",
  surfaceColorSecondary: "var(--goto-surface-color-secondary)",
  surfaceColorSecondaryInverted: "var(--goto-surface-color-secondary-inverted)",
  surfaceColorTertiary: "var(--goto-surface-color-tertiary)",
  surfaceColorInverted: "var(--goto-surface-color-inverted)",
  surfaceColorPersistent: "var(--goto-surface-color-persistent)",
  surfaceColorBrandDefault: "var(--goto-surface-color-brand-default)",
  surfaceColorBrandSecondary: "var(--goto-surface-color-brand-secondary)",
  surfaceColorSuccessDefault: "var(--goto-surface-color-success-default)",
  surfaceColorSuccessSecondary: "var(--goto-surface-color-success-secondary)",
  surfaceColorDangerDefault: "var(--goto-surface-color-danger-default)",
  surfaceColorDangerSecondary: "var(--goto-surface-color-danger-secondary)",
  surfaceColorWarningDefault: "var(--goto-surface-color-warning-default)",
  surfaceColorWarningSecondary: "var(--goto-surface-color-warning-secondary)",
  surfaceColorUtilityPurple: "var(--goto-surface-color-utility-purple)",
  surfaceColorUtilityOrange: "var(--goto-surface-color-utility-orange)",
  surfaceColorUtilityBlue: "var(--goto-surface-color-utility-blue)",
  typeColorDefault: "var(--goto-type-color-default)",
  typeColorSecondary: "var(--goto-type-color-secondary)",
  typeColorInverted: "var(--goto-type-color-inverted)",
  typeColorSecondaryInverted: "var(--goto-type-color-secondary-inverted)",
  typeColorPersistent: "var(--goto-type-color-persistent)",
  typeColorBrandDefault: "var(--goto-type-color-brand-default)",
  typeColorBrandPersistent: "var(--goto-type-color-brand-persistent)",
  typeColorSuccess: "var(--goto-type-color-success)",
  typeColorDanger: "var(--goto-type-color-danger)",
  typeColorWarning: "var(--goto-type-color-warning)",
  typeColorDisabled: "var(--goto-type-color-disabled)",
  typeColorPersistentDisabled: "var(--goto-type-color-persistent-disabled)",
  iconColorDefault: "var(--goto-icon-color-default)",
  iconColorSecondary: "var(--goto-icon-color-secondary)",
  iconColorInverted: "var(--goto-icon-color-inverted)",
  iconColorPersistent: "var(--goto-icon-color-persistent)",
  iconColorBrandDefault: "var(--goto-icon-color-brand-default)",
  iconColorBrandPersistent: "var(--goto-icon-color-brand-persistent)",
  iconColorSuccess: "var(--goto-icon-color-success)",
  iconColorDanger: "var(--goto-icon-color-danger)",
  iconColorWarning: "var(--goto-icon-color-warning)",
  iconColorDisabled: "var(--goto-icon-color-disabled)",
  iconColorPersistentDisabled: "var(--goto-icon-color-persistent-disabled)",
  interactiveColorNeutralDefault: "var(--goto-interactive-color-neutral-default)",
  interactiveColorNeutralHover: "var(--goto-interactive-color-neutral-hover)",
  interactiveColorNeutralPressed: "var(--goto-interactive-color-neutral-pressed)",
  interactiveColorPrimaryDefault: "var(--goto-interactive-color-primary-default)",
  interactiveColorPrimaryHover: "var(--goto-interactive-color-primary-hover)",
  interactiveColorPrimaryPressed: "var(--goto-interactive-color-primary-pressed)",
  interactiveColorSecondaryDefault: "var(--goto-interactive-color-secondary-default)",
  interactiveColorSecondaryHover: "var(--goto-interactive-color-secondary-hover)",
  interactiveColorSecondaryPressed: "var(--goto-interactive-color-secondary-pressed)",
  interactiveColorSuccessDefault: "var(--goto-interactive-color-success-default)",
  interactiveColorSuccessHover: "var(--goto-interactive-color-success-hover)",
  interactiveColorSuccessPressed: "var(--goto-interactive-color-success-pressed)",
  interactiveColorDangerDefault: "var(--goto-interactive-color-danger-default)",
  interactiveColorDangerHover: "var(--goto-interactive-color-danger-hover)",
  interactiveColorDangerPressed: "var(--goto-interactive-color-danger-pressed)",
  interactiveColorBrandDefault: "var(--goto-interactive-color-brand-default)",
  interactiveColorBrandHover: "var(--goto-interactive-color-brand-hover)",
  interactiveColorBrandPressed: "var(--goto-interactive-color-brand-pressed)",
  interactiveColorPersistentDefault: "var(--goto-interactive-color-persistent-default)",
  interactiveColorPersistentHover: "var(--goto-interactive-color-persistent-hover)",
  interactiveColorPersistentPressed: "var(--goto-interactive-color-persistent-pressed)",
  interactiveColorPersistentActive: "var(--goto-interactive-color-persistent-active)",
  interactiveColorDisabled: "var(--goto-interactive-color-disabled)",
  borderColorDefault: "var(--goto-border-color-default)",
  borderColorSecondary: "var(--goto-border-color-secondary)",
  borderColorInverted: "var(--goto-border-color-inverted)",
  borderColorPersistent: "var(--goto-border-color-persistent)",
  borderColorBrand: "var(--goto-border-color-brand)",
  borderColorSuccess: "var(--goto-border-color-success)",
  borderColorWarning: "var(--goto-border-color-warning)",
  borderColorDanger: "var(--goto-border-color-danger)",
  focusBorderColorDefault: "var(--goto-focus-border-color-default)",
  focusBorderColorSuccess: "var(--goto-focus-border-color-success)",
  focusBorderColorDanger: "var(--goto-focus-border-color-danger)",
  focusBorderColorPersistent: "var(--goto-focus-border-color-persistent)",
  focusColorHighlightDefault: "var(--goto-focus-color-highlight-default)",
  focusColorHighlightSuccess: "var(--goto-focus-color-highlight-success)",
  focusColorHighlightDanger: "var(--goto-focus-color-highlight-danger)",
  focusColorHighlightPersistent: "var(--goto-focus-color-highlight-persistent)",
  scrimColor: "var(--goto-scrim-color)",
  gradientColorSkeleton: "var(--goto-gradient-color-skeleton)",
  overflowTopGradientDefault: "var(--goto-overflow-top-gradient-default)",
  overflowRightGradientDefault: "var(--goto-overflow-right-gradient-default)",
  overflowBottomGradientDefault: "var(--goto-overflow-bottom-gradient-default)",
  overflowLeftGradientDefault: "var(--goto-overflow-left-gradient-default)",
  overflowTopGradientSecondary: "var(--goto-overflow-top-gradient-secondary)",
  overflowRightGradientSecondary: "var(--goto-overflow-right-gradient-secondary)",
  overflowBottomGradientSecondary: "var(--goto-overflow-bottom-gradient-secondary)",
  overflowLeftGradientSecondary: "var(--goto-overflow-left-gradient-secondary)",
  highlightBackgroundColor: "var(--goto-highlight-background-color)",
  highlightTypeColor: "var(--goto-highlight-type-color)",
  badgeColorZomp: "var(--goto-badge-color-zomp)",
  badgeColorRed: "var(--goto-badge-color-red)",
  badgeColorViolet: "var(--goto-badge-color-violet)",
  badgeColorOrange: "var(--goto-badge-color-orange)",
  badgeColorAzure: "var(--goto-badge-color-azure)",
  badgeColorDeeppurple: "var(--goto-badge-color-deeppurple)",
  badgeColorGreen: "var(--goto-badge-color-green)",
  badgeColorBlue: "var(--goto-badge-color-blue)",
  badgeColorCitron: "var(--goto-badge-color-citron)",
  badgeColorBlack: "var(--goto-badge-color-black)",
  badgeColorGrey: "var(--goto-badge-color-grey)",
  badgeColorQueenblue: "var(--goto-badge-color-queenblue)",
  badgeColorBrand: "var(--goto-badge-color-brand)",
  badgeColorDisabled: "var(--goto-badge-color-disabled)",
  badgeColorAssist: "var(--goto-badge-color-assist)",
  badgeColorCustomer: "var(--goto-badge-color-customer)",
  badgeColorGotoresolve: "var(--goto-badge-color-gotoresolve)",
  badgeColorMeeting: "var(--goto-badge-color-meeting)",
  badgeColorMessage: "var(--goto-badge-color-message)",
  badgeColorTraining: "var(--goto-badge-color-training)",
  badgeColorVoice: "var(--goto-badge-color-voice)",
  badgeColorWebinar: "var(--goto-badge-color-webinar)",
  badgeColorAudio: "var(--goto-badge-color-audio)",
  badgeColorCustom: "var(--goto-badge-color-custom)",
  badgeColorFiles: "var(--goto-badge-color-files)",
  badgeColorDigitalEngagement: "var(--goto-badge-color-digital-engagement)",
  avatarColor00: "var(--goto-avatar-color-00)",
  avatarColor01: "var(--goto-avatar-color-01)",
  avatarColor02: "var(--goto-avatar-color-02)",
  avatarColor10: "var(--goto-avatar-color-10)",
  avatarColor11: "var(--goto-avatar-color-11)",
  avatarColor12: "var(--goto-avatar-color-12)",
  avatarColor20: "var(--goto-avatar-color-20)",
  avatarColor21: "var(--goto-avatar-color-21)",
  avatarColor22: "var(--goto-avatar-color-22)",
  avatarColor30: "var(--goto-avatar-color-30)",
  avatarColor31: "var(--goto-avatar-color-31)",
  avatarColor32: "var(--goto-avatar-color-32)",
  avatarColor40: "var(--goto-avatar-color-40)",
  avatarColor41: "var(--goto-avatar-color-41)",
  avatarColor42: "var(--goto-avatar-color-42)",
  avatarColor50: "var(--goto-avatar-color-50)",
  avatarColor51: "var(--goto-avatar-color-51)",
  avatarColor52: "var(--goto-avatar-color-52)",
  avatarColorPrimary: "var(--goto-avatar-color-primary)",
  avatarColorSecondary: "var(--goto-avatar-color-secondary)",
  avatarInteractiveColorOverlayHover: "var(--goto-avatar-interactive-color-overlay-hover)",
  avatarInteractiveColorOverlayPressed: "var(--goto-avatar-interactive-color-overlay-pressed)",
  datavizColorBlueDefault: "var(--goto-dataviz-color-blue-default)",
  datavizColorBlueHover: "var(--goto-dataviz-color-blue-hover)",
  datavizColorBluePressed: "var(--goto-dataviz-color-blue-pressed)",
  datavizColorGreenDefault: "var(--goto-dataviz-color-green-default)",
  datavizColorGreenHover: "var(--goto-dataviz-color-green-hover)",
  datavizColorGreenPressed: "var(--goto-dataviz-color-green-pressed)",
  datavizColorRedDefault: "var(--goto-dataviz-color-red-default)",
  datavizColorRedHover: "var(--goto-dataviz-color-red-hover)",
  datavizColorRedPressed: "var(--goto-dataviz-color-red-pressed)",
  datavizColorYellowDefault: "var(--goto-dataviz-color-yellow-default)",
  datavizColorYellowHover: "var(--goto-dataviz-color-yellow-hover)",
  datavizColorYellowPressed: "var(--goto-dataviz-color-yellow-pressed)",
  datavizColorPurpleDefault: "var(--goto-dataviz-color-purple-default)",
  datavizColorPurpleHover: "var(--goto-dataviz-color-purple-hover)",
  datavizColorPurplePressed: "var(--goto-dataviz-color-purple-pressed)",
  blue500: "var(--goto-blue-500)",
  blue200: "var(--goto-blue-200)",
  blue100: "var(--goto-blue-100)",
  blue600: "var(--goto-blue-600)",
  blue300: "var(--goto-blue-300)",
  blue700: "var(--goto-blue-700)",
  blue400: "var(--goto-blue-400)",
  green500: "var(--goto-green-500)",
  green200: "var(--goto-green-200)",
  green100: "var(--goto-green-100)",
  green600: "var(--goto-green-600)",
  green300: "var(--goto-green-300)",
  green700: "var(--goto-green-700)",
  green400: "var(--goto-green-400)",
  red500: "var(--goto-red-500)",
  red200: "var(--goto-red-200)",
  red100: "var(--goto-red-100)",
  red600: "var(--goto-red-600)",
  red300: "var(--goto-red-300)",
  red700: "var(--goto-red-700)",
  red400: "var(--goto-red-400)",
  yellow500: "var(--goto-yellow-500)",
  yellow200: "var(--goto-yellow-200)",
  yellow100: "var(--goto-yellow-100)",
  yellow600: "var(--goto-yellow-600)",
  yellow300: "var(--goto-yellow-300)",
  yellow700: "var(--goto-yellow-700)",
  yellow400: "var(--goto-yellow-400)",
  purple500: "var(--goto-purple-500)",
  purple200: "var(--goto-purple-200)",
  purple100: "var(--goto-purple-100)",
  purple600: "var(--goto-purple-600)",
  purple300: "var(--goto-purple-300)",
  purple700: "var(--goto-purple-700)",
  purple400: "var(--goto-purple-400)",
  orange500: "var(--goto-orange-500)",
  orange200: "var(--goto-orange-200)",
  orange100: "var(--goto-orange-100)",
  orange600: "var(--goto-orange-600)",
  orange300: "var(--goto-orange-300)",
  orange700: "var(--goto-orange-700)",
  orange400: "var(--goto-orange-400)",
  neutral900: "var(--goto-neutral-900)",
  neutral850: "var(--goto-neutral-850)",
  neutral800: "var(--goto-neutral-800)",
  neutral700: "var(--goto-neutral-700)",
  neutral600: "var(--goto-neutral-600)",
  neutral500: "var(--goto-neutral-500)",
  neutral400: "var(--goto-neutral-400)",
  neutral300: "var(--goto-neutral-300)",
  neutral200: "var(--goto-neutral-200)",
  neutral100: "var(--goto-neutral-100)",
  neutral050: "var(--goto-neutral-050)",
  neutral000: "var(--goto-neutral-000)",
  brandColorPrimaryYellow: "var(--goto-brand-color-primary-yellow)",
  brandColorBlack: "var(--goto-brand-color-black)",
  brandColorWhite: "var(--goto-brand-color-white)",
  brandColorAdminBlue: "var(--goto-brand-color-admin-blue)",
  brandColorResolvePurple: "var(--goto-brand-color-resolve-purple)",
  brandColorGotoAppGreen: "var(--goto-brand-color-goto-app-green)",
  brandColorSecureRed: "var(--goto-brand-color-secure-red)",
  brandColorGray100: "var(--goto-brand-color-gray-100)",
  brandColorGray200: "var(--goto-brand-color-gray-200)",
  brandColorGray300: "var(--goto-brand-color-gray-300)",
  brandColorGray400: "var(--goto-brand-color-gray-400)",
  elevationNone: "var(--goto-elevation-none)",
  elevationSmall: "var(--goto-elevation-small)",
  elevationMedium: "var(--goto-elevation-medium)",
  elevationLarge: "var(--goto-elevation-large)",
  elevationXlarge: "var(--goto-elevation-xlarge)",
  blurMedium: "var(--goto-blur-medium)",
  blurSmall: "var(--goto-blur-small)",
  blurLarge: "var(--goto-blur-large)",
  blurXlarge: "var(--goto-blur-xlarge)",
  radiusNone: "var(--goto-radius-none)",
  radiusSmall: "var(--goto-radius-small)",
  radiusMedium: "var(--goto-radius-medium)",
  radiusLarge: "var(--goto-radius-large)",
  radiusXlarge: "var(--goto-radius-xlarge)",
  radiusCircle: "var(--goto-radius-circle)",
  spacing00: "var(--goto-spacing-00)",
  spacing01: "var(--goto-spacing-01)",
  spacing02: "var(--goto-spacing-02)",
  spacing03: "var(--goto-spacing-03)",
  spacing04: "var(--goto-spacing-04)",
  spacing05: "var(--goto-spacing-05)",
  spacing06: "var(--goto-spacing-06)",
  spacing07: "var(--goto-spacing-07)",
  spacing08: "var(--goto-spacing-08)",
  spacing09: "var(--goto-spacing-09)",
  spacing10: "var(--goto-spacing-10)",
  spacing11: "var(--goto-spacing-11)",
  layout00: "var(--goto-layout-00)",
  layout01: "var(--goto-layout-01)",
  layout02: "var(--goto-layout-02)",
  layout03: "var(--goto-layout-03)",
  layout04: "var(--goto-layout-04)",
  layout05: "var(--goto-layout-05)",
  layout06: "var(--goto-layout-06)",
  layout07: "var(--goto-layout-07)",
  zIndexDeep: "var(--goto-z-index-deep)",
  zIndexDefault: "var(--goto-z-index-default)",
  zIndexMasked: "var(--goto-z-index-masked)",
  zIndexMask: "var(--goto-z-index-mask)",
  zIndexSticky: "var(--goto-z-index-sticky)",
  zIndexHeader: "var(--goto-z-index-header)",
  zIndexToast: "var(--goto-z-index-toast)",
  zIndexDropdown: "var(--goto-z-index-dropdown)",
  zIndexOverlay: "var(--goto-z-index-overlay)",
  zIndexLoading: "var(--goto-z-index-loading)",
  zIndexModal: "var(--goto-z-index-modal)",
  durationSnappy01: "var(--goto-duration-snappy-01)",
  durationSnappy02: "var(--goto-duration-snappy-02)",
  durationModest01: "var(--goto-duration-modest-01)",
  durationModest02: "var(--goto-duration-modest-02)",
  durationLethargic01: "var(--goto-duration-lethargic-01)",
  durationLethargic02: "var(--goto-duration-lethargic-02)",
  durationSluggish: "var(--goto-duration-sluggish)",
  standardEasing: "var(--goto-standard-easing)",
  entranceEasing: "var(--goto-entrance-easing)",
  exitEasing: "var(--goto-exit-easing)",
  mqSmall: "var(--goto-mq-small)",
  mqMedium: "var(--goto-mq-medium)",
  mqLarge: "var(--goto-mq-large)",
  mqXlarge: "var(--goto-mq-xlarge)",
  headingXlarge: "var(--goto-heading-xlarge)",
  headingLarge: "var(--goto-heading-large)",
  headingMedium: "var(--goto-heading-medium)",
  headingSmall: "var(--goto-heading-small)",
  bodyLarge: "var(--goto-body-large)",
  bodyLargeStrong: "var(--goto-body-large-strong)",
  bodyMedium: "var(--goto-body-medium)",
  bodyMediumStrong: "var(--goto-body-medium-strong)",
  bodySmall: "var(--goto-body-small)",
  bodySmallStrong: "var(--goto-body-small-strong)",
  captionMedium: "var(--goto-caption-medium)",
  captionMediumStrong: "var(--goto-caption-medium-strong)",
  captionSmall: "var(--goto-caption-small)",
  captionSmallStrong: "var(--goto-caption-small-strong)",
  codeMedium: "var(--goto-code-medium)",
  codeSmall: "var(--goto-code-small)",
  buttonXlarge: "var(--goto-button-xlarge)",
  buttonLarge: "var(--goto-button-large)",
  buttonMedium: "var(--goto-button-medium)",
  buttonSmall: "var(--goto-button-small)",
  avatarXxxlarge: "var(--goto-avatar-xxxlarge)",
  avatarXxlarge: "var(--goto-avatar-xxlarge)",
  avatarXlarge: "var(--goto-avatar-xlarge)",
  avatarLarge: "var(--goto-avatar-large)",
  avatarMedium: "var(--goto-avatar-medium)",
  avatarSmall: "var(--goto-avatar-small)",
  avatarXsmall: "var(--goto-avatar-xsmall)",
  fontFamily: "var(--goto-font-family)",
  fontFamilyMono: "var(--goto-font-family-mono)"
};
